import styled from 'styled-components';
import { InputTextAreaProps } from './inputTextArea.types';

type InputTextAreaContainerProps = Pick<InputTextAreaProps, 'wrapLabel'>;

export const InputTextAreaContainer = styled.div<InputTextAreaContainerProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  min-width: 9.375rem;
  gap: 0.3rem;

  label {
    white-space: ${(p) => (p.wrapLabel ? 'normal' : 'nowrap')};
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
